<template>
    <div>
        <div class="ml-auto text-right">
            <router-link class="btn buttons-csv buttons-html5 btn-outline-primary" :to="'/dashboard/salon_menu_package'">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.create') + $t(`subMenu.salon_menu_package`)}}</span>
            </router-link>
        </div>
        <form @submit.prevent="submitPromoValue">
            <div class="mb-5">
                <div class="form-group">
                    <label class="form-label">{{$t(`subMenu.salon_menu_package`)}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-box-alt"></i>
                            </span>
                        </div>
                        <input ref="packageInput" block v-b-toggle.accPackageList @keydown.prevent class="form-control bg-transparent pl-3" :placeholder="$t(`subMenu.salon_menu_package`)" v-model="selectedPackage" required="" :disabled="isEdit ? true : false">
                    </div>
                </div>
                <b-collapse id="accPackageList" accordion="accordion" role="tabpanel">
                    <b-card no-body>
                        <b-card-body>
                            <h5 class="card-title">{{$t('header.list_of', {'item': $t(`subMenu.salon_menu_package`)})}}</h5>
                            <div class="row mb-2">
                                <div class="col-md-12 col-sm-12">
                                    <div class="dataTables_filter mb-2">
                                        <label class="d-flex mb-0">
                                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchPackage" @keypress.enter="filterSearchPackage">
                                            <button type="button" class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchPackage">
                                                <i class="fas fa-search"></i>
                                            </button>
                                        </label>
                                    </div>
                                    <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
                                </div>
                            </div>
                            <ul class="nav nav-tabs mb-3">
                                <li class="nav-item" v-for="c in packageCategory" :key="c.id">
                                    <a :class="{'active': selectedCategory == c.id}" class="nav-link" role="tab" @click="filterCategory(c.id)">{{c.text}}</a>
                                </li>
                            </ul>
                            <div class="demo package-list">
                                <button v-for="s in packageItems" :key="s.itemID" type="button" class="btn btn-lg btn-outline-primary waves-effect waves-themed text-left fs-md" @click="selectItem(s.itemID, s.title, s.price)">
                                    <span class="d-block">{{s.title}}</span>
                                    <span class="d-block border-top pt-1 mt-1"><i class="fas fa-tag mr-2"></i>{{getCategoryText(s.category)}}</span>
                                    <span class="d-block border-top pt-1 mt-1"><i class="fas fa-dollar-sign mr-3"></i>{{formatPrice(s.price)}} {{$t('label.ea')}}.</span>
                                </button>
                                <div class="panel-tag mt-3" v-if="packageItems.length == 0">{{$t('table.no_records')}}</div>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-collapse>
                <div class="form-group">
                    <label class="form-label">{{$t('subMenu.salon_menu_package') + ' ' + $t('label.details')}}</label>
                    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <table v-if="!isSpinnerShow && packageDetails.length != 0 " class="table table-striped">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key" :style="[tblHeader.key == 'item' ? {'width': '80%'} : '']">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>{{$t('label.credit')}}</td><td>{{formatPrice(packageDetails.package.credits)}}</td></tr>
                            <tr><td>{{$t('label.point')}}</td><td>{{packageDetails.package.points}}</td></tr>
                            <tr v-if="packageDetails.package.items.length !=0" class="fw-500 text-primary" style="text-decoration: underline">{{$t('subMenu.salon_menu_service') + '/' + $t('subMenu.salon_menu_product')}}</tr>
                            <tr v-for="item in packageDetails.package.items" :key="item.itemID">
                                <td>{{item.quantity}}x {{item.title}} [{{formatPrice(item.unitPrice)}}] {{$t('label.ea')}}</td>
                                <td>{{calculateItemPrice(item.unitPrice, item.quantity)}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!isSpinnerShow && packageDetails.length == 0 " class="alert alert-primary alert-dismissible" >
                    {{$t('message.info.select_package')}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 mb-2">
                        <div class="form-group">
                            <label class="form-label text-muted">{{$t('label.package_value')}}</label>
                            <input type="text" class="form-control" disabled="" v-model="packageValue">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 mb-2">
                        <label class="form-label">{{$t('label.total_unit')}}</label>
                        <input class="form-control" type="number" :placeholder="$t('label.total_unit')" v-model="totalUnit" :min="0"/>
                    </div>
                </div>
            </div>
            <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnRewardList()">{{$t('button_link.cancel')}}</button>
            <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mr-3" @click="returnPreviousStep(1)">{{$t('button_link.prev')}}</button>
            <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
        </form>
    </div>
</template>
<script>
import {handleSessionExpired, getCategoryText} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
export default {
    name: "rewardFormValue",
    props: {
        isEdit: { type: Boolean }
    },
    data(){
        return {
            isSpinnerShow: false,
            selectedPackage: "", 
            searchPackage: "",
            searchFilter:"", categoryFilter: "",
            packageCategory: [], selectedCategory: "all",
            packageItems:[], packageDetails: [],
            packageValue: 0, totalUnit: 0, 
            selectedItemID: 0
        }
    },
    computed:{
        fields(){
            return[
                { key: 'item', label: this.$i18n.t('table.header.item'), thClass: 'thead-themed align-middle'},
                { key: 'unit_price', label: this.$i18n.t('table.header.unit_price'), thClass: 'thead-themed align-middle'}
            ]
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setCategory()
        }
    },
    methods:{
        formatPrice(p){
            return formatPrice(p)
        },
        calculateItemPrice(p, q){
            return formatPrice(p*q)
        },
        returnRewardList(){
            this.$emit('returnRewardList')
        },
        returnPreviousStep(step){
            this.$emit('returnPreviousStep', step)
        },
        getCategoryText(id){
            return getCategoryText(id, this.packageCategory)
        },
        submitPromoValue(){
            var data = {
                itemID: this.selectedItemID,
                total: this.totalUnit
            }
            this.$emit('submitPromoValue', data, 2, "")
        },
        async editReward(data){
            this.totalUnit = data.total
            this.selectedItemID = data.itemID

            this.packageDetails = await this.getItemDetails();
            this.selectedPackage = this.packageDetails.title + " [" + formatPrice(this.packageDetails.price) + "]" + this.$i18n.t('label.ea')
            this.packageValue = formatPrice(this.packageDetails.price)
        },
        clearFilter(){
            this.searchFilter = this.categoryFilter = this.searchPackage = ""
            this.selectedCategory = "all"
            this.filterPackageItems(this.categoryFilter, this.searchFilter)
        },
        filterCategory(id){
            this.selectedCategory = id;
            this.categoryFilter = id == "all" ? "" : "&category=" + id;
            this.filterPackageItems(this.categoryFilter, this.searchFilter)
        },
        filterSearchPackage(){
            this.selectedCategory = "all";
            this.searchFilter = this.searchPackage == "" ? "" : "&search=" + this.searchPackage;
            this.filterPackageItems(this.categoryFilter, this.searchFilter)
        },
        filterPackageItems(category, search){
            this.getPackageItem(category + search)
        },
        async selectItem(id, title, price){
            this.selectedPackage = title + " [" + formatPrice(price) + "]" + this.$i18n.t('label.ea')
            this.selectedItemID = id;
            this.$refs.packageInput.click()

            this.packageDetails = await this.getItemDetails();
            this.packageValue = formatPrice(price)
        },
        async getItemDetails(){
            let $vm = this;
            let QUERY_STRING = "/" + this.selectedItemID + this.$api.PACKAGE_DETAIL
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            $vm.isSpinnerShow = true;
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data;
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        getPackageItem(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=package" + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.packageItems = response.data.items;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        setCategory(){
            this.packageCategory = []
            var category = JSON.parse(this.$store.state.category);
            this.packageCategory.push({id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})});
            
            for(var i=0; i<category.package.length; i++){
                this.packageCategory.push({id: i, text: category.package[i]});
            }
        }
    },
    mounted(){
        let $vm = this;
        $vm.setCategory()
        $vm.getPackageItem("");
    }
}
</script>
<style scoped>
.package-list{
    height: 50vh;
    overflow-y: auto;
}
.nav-link{
    cursor: pointer;
}
.search:hover{
    background: #d6d6d6;
    border: 1px solid #d6d6d6;
}
</style>